import React from 'react'
import Queryable from '../../UI/Queryable/Queryable'

import '../TrafficEntry.module.sass'
import miscStyles from '../misc.module.sass'

interface LatencyProps {
  microseconds: number
}

export const Latency: React.FC<LatencyProps> = ({ microseconds }) => {
  return (
    <>
      <Queryable
        className={miscStyles.protocol}
        query={`elapsedTime >= ${microseconds}`}
        displayIconOnMouseOver={true}
        flipped={true}
        iconStyle={{ zIndex: '5', position: 'relative', right: '14px' }}
        tooltipStyle={{ marginLeft: '10px' }}
      >
        <span className='DataText' style={{ fontWeight: 500 }}>
          {Math.round(microseconds)} μs
        </span>
      </Queryable>
    </>
  )
}
